import type { Connector } from '@particle-network/connector-core';
import type { Config } from '../createConfig';
import { deepEqual } from '../utils/deepEqual';

export type GetConnectorsReturnType = readonly Connector[];

let previousConnectors: readonly Connector[] = [];

export function getConnectors(config: Config): GetConnectorsReturnType {
  const connectors = config.connectors;
  if (deepEqual(previousConnectors, connectors)) return previousConnectors;
  previousConnectors = connectors;
  return connectors;
}
